import type { CuratedItem } from "~types/types";

export default function getMergedAndDedupedItems(
    itemsA: CuratedItem[],
    itemsB: CuratedItem[]
) {
    const resultMap = [...itemsA, ...itemsB].reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
    }, {} as { [key: string]: CuratedItem });

    return Object.values(resultMap);
}
